"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledRoundButton = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _theme = require("../../constants/theme");
var _UnreachableCaseError = require("../../entities/UnreachableCaseError");
var _createBorderCss = _interopRequireDefault(require("../../utils/createBorderCss"));
var _excluded = ["type", "children", "as"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var RoundButton = function RoundButton(_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    children = _ref.children,
    as = _ref.as,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledRoundButton, Object.assign({
    ref: ref,
    as: as,
    type: type
  }, props), children);
};
var primaryCss = (0, _styledComponents.css)(["color:", ";background:", ";--border-color:", ";:focus,:hover{", ";--border-color:", ";}:active{background:", ";--border-color:", ";}:disabled{background:", ";--border-color:", " !important;color:", " !important;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.neutral['0'];
}, function (_ref3) {
  var theme = _ref3.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.main);
}, function (_ref4) {
  var theme = _ref4.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.main);
}, (0, _createBorderCss["default"])('2px'), function (_ref5) {
  var theme = _ref5.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.main, 1);
}, function (_ref6) {
  var theme = _ref6.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.main, 1);
}, function (_ref7) {
  var theme = _ref7.theme;
  return (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.main, 1);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.neutral['0'];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.neutral['30'];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.neutral['40'];
});
var outlinePrimaryCss = (0, _styledComponents.css)(["color:", ";--border-color:", ";:hover,:focus,:active{", ";--border-color:", ";}:active{background:", ";}:disabled{--border-color:", " !important;color:", " !important;background:#e0e0e0 !important;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.neutral['70'];
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.neutral['30'];
}, (0, _createBorderCss["default"])('2px'), function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.primary['40'];
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.primary['5'];
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.neutral['30'];
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.neutral['40'];
});
var outlineInvertedCss = (0, _styledComponents.css)(["color:", ";--border-color:currentColor;background:rgba(0,0,0,0.2);:hover,:focus{", ";}:active{--border-color:", ";background:", ";color:", ";}:disabled{color:", " !important;--border-color:", " !important;}"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.neutral['0'];
}, (0, _createBorderCss["default"])('2px'), function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.neutral['0'];
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.neutral['0'];
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.neutral['70'];
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.neutral['30'];
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.neutral['30'];
});
var getCss = function getCss(variant) {
  switch (variant) {
    case 'primary':
      return primaryCss;
    case 'outline':
      return outlinePrimaryCss;
    case 'outline-inverted':
      return outlineInvertedCss;
    default:
      // ensures this switch is exhaustive
      throw new _UnreachableCaseError.UnreachableCaseError(variant);
  }
};
var getSizeCss = function getSizeCss(size) {
  switch (size) {
    case 'small':
      return (0, _styledComponents.css)(["height:3.2rem;width:3.2rem;"]);
    case 'medium':
      return (0, _styledComponents.css)(["height:4rem;width:4rem;"]);
    case 'large':
      return (0, _styledComponents.css)(["height:", ";width:", ";"], function (_ref23) {
        var theme = _ref23.theme;
        return theme.spacing['70_XLarge'];
      }, function (_ref24) {
        var theme = _ref24.theme;
        return theme.spacing['70_XLarge'];
      });
    default:
      throw new _UnreachableCaseError.UnreachableCaseError(size);
  }
};
var StyledRoundButton = exports.StyledRoundButton = _styledComponents["default"].button.withConfig({
  displayName: "RoundButton__StyledRoundButton",
  componentId: "sc-87fs5d-0"
})(["background:none;color:currentColor;border:none;border-radius:50%;padding:0;display:inline-flex;align-items:center;justify-content:center;outline:none;-webkit-font-smoothing:antialiased;", ";", ";:disabled{cursor:not-allowed;}", ";"], function (_ref25) {
  var _ref25$variant = _ref25.variant,
    variant = _ref25$variant === void 0 ? 'primary' : _ref25$variant;
  return getCss(variant);
}, (0, _createBorderCss["default"])('1px'), function (_ref26) {
  var _ref26$size = _ref26.size,
    size = _ref26$size === void 0 ? 'medium' : _ref26$size;
  return getSizeCss(size);
});
var _default = exports["default"] = (0, _react.forwardRef)(RoundButton);
//# sourceMappingURL=RoundButton.js.map